import { jsx as _jsx } from "react/jsx-runtime";
import MuiPopper from '@mui/material/Popper';
import React from 'react';
const PopperComponent = (props) => {
    const { ownPopperId, ...muiProps } = props;
    return (_jsx(MuiPopper, { id: ownPopperId, modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 5]
                }
            }
        ], ...muiProps }));
};
export default { PopperComponent };
